module.exports = __webpack_public_path__ + "static/media/background.c0bc9c3a.jpg";